type Return = {
  formattedData?: { time: number, value: number }[],
  pair: string,
  error?: string
}

export const getFormattedPrice = (
  dataFrom: any,
  dataTo: any,
  fromToken?: string,
  toToken?: string
): Return => {

  let formattedData = [];
  let error = '';

  // Both token unavailable
  if (!dataTo?.prices?.length && !dataFrom?.prices?.length) {
    return { pair: `${toToken}/${fromToken}`, formattedData: [] }
  }
  // Only fromToken available  
  else if (!dataTo?.prices?.length && dataFrom?.prices?.length) {
    if (fromToken === "USDC" || fromToken === "USDT") {
      formattedData = []    // no point of showing chart for stable token 
    } else {
      formattedData = dataFrom?.prices?.map((d: any) => ({
        time: Date.parse(d.time.toDate()) / 1000,
        value: 1 / d.price,
      }))
      error = "No price history for " + toToken;
      toToken = "USDC"
    }
  }
  // Only toToken available
  else if (!dataFrom?.prices?.length && dataTo?.prices?.length) {
    if (toToken === "USDC" || toToken === "USDT") {
      formattedData = []    // no point of showing chart for stable token
    } else {
      formattedData = dataTo?.prices?.map((d: any) => ({
        time: Date.parse(d.time.toDate()) / 1000,
        value: d.price,
      }))
      error = "No price history for " + fromToken;
      fromToken = "USDC"
    }
  }
  // Both token available
  else if (dataTo?.prices?.length && dataFrom?.prices?.length) {
    formattedData = dataTo?.prices?.map((d: any) => {
      const matchingPrice = dataFrom?.prices.filter((f: any) => f.time.isEqual(d.time));

      if (matchingPrice?.length) {
        return {
          time: Date.parse(d.time.toDate()) / 1000,
          value: d.price / (matchingPrice?.[0]?.price),
        }
      } else {
        return {
          time: 1,
          price: 1
        }
      }
    }) ?? []  // just to be safe
  }
  return { formattedData, pair: `${toToken}/${fromToken}`, error }
}